import { gql } from "@apollo/client";

export default gql`
  mutation deleteOrgWideCareerLevel($organizationId: Int!, $level: Int!) {
    deleteCareerLevel(organizationId: $organizationId, level: $level) {
      ok
    }
  }
`;
